import React, { type FC } from 'react';
import Realtor from '../Realtor';
import RLEEntryPoint from '../RLEEntryPoint';
import './RealtorList.scss';

interface RealtorListProps {
  hits: any[];
}

const RLE_ENTRY_POINT_INDEX = 2;

const RealtorList: FC<RealtorListProps> = ({ hits }) => {
  const shouldRenderRLEEntryPoint = (index) => {
    if (hits.length <= RLE_ENTRY_POINT_INDEX) {
      return index === hits.length - 1;
    }
    return index === RLE_ENTRY_POINT_INDEX;
  };

  return hits ? (
    <section>
      {hits.map(({ view }: any, index) => (
        <React.Fragment key={view.cwid}>
          <Realtor {...view} />
          {shouldRenderRLEEntryPoint(index) && (
            <RLEEntryPoint
              withNegativeMargin={hits.length > RLE_ENTRY_POINT_INDEX}
            />
          )}
        </React.Fragment>
      ))}
    </section>
  ) : null;
};

export default RealtorList;
